export function formatCurrency (
  amount: number,
  locale: string,
  currency = 'EUR'
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(amount)
}

export function formatCurrencyParts (
  amount: number,
  locale: string,
  currency = 'EUR'
): { value: string; unit: string } {
  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).formatToParts(amount)

  return {
    value: parts
      .filter(part => part.type !== 'currency')
      .map(part => part.value)
      .join('')
      .trim(),
    unit: parts.find(part => part.type === 'currency')?.value ?? currency
  }
}

export function formatPoints (points: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(points)
}

export function getInitials (
  firstName?: string,
  lastName?: string
): string {
  const first = firstName?.trim().charAt(0) ?? ''
  const last = lastName?.trim().charAt(0) ?? ''
  return (first + last).toUpperCase() || '?'
}
